"use client";

import Image from "next/image";

import { UkFlag } from "@/components/editorial/bands/drawing-variant-regions";

/** The third-party AI the pricing cards name. */
export const AI_TOOLS = [
  { name: "ChatGPT", icon: "/concepts/source-icons/chatgpt.svg" },
  { name: "Claude", icon: "/concepts/source-icons/claude.svg" },
  { name: "Gemini", icon: "/concepts/source-icons/gemini.svg" },
] as const;

/** The Union flag at text size, for UK lines and actions. */
export function UkMark() {
  return (
    <svg aria-hidden viewBox="0 0 100 66.67" className="h-[0.75em] w-auto shrink-0 overflow-hidden rounded-[2px]">
      <UkFlag x={0} y={0} width={100} height={66.67} />
    </svg>
  );
}

/** The AI tools' marks in a row. */
export function AiMarks({ size = 16 }: { size?: number }) {
  return (
    <span className="flex items-center gap-1">
      {AI_TOOLS.map((tool) => (
        <Image key={tool.name} src={tool.icon} alt="" width={size} height={size} className="shrink-0 object-contain" />
      ))}
    </span>
  );
}
